import { LandingShell } from '../features/landing/LandingShell.jsx';
import { GroupRing } from '../features/landing/GroupRing.jsx';

/**
 * `/groups`: the same product, pitched at a table rather than a person.
 *
 * A separate page so the group feature can be marketed on its own — a poster in
 * a dining hall, a link in a group chat — without the visitor having to work
 * out that the swiping thing also does this. The ring is the argument: four
 * people swiping at once, the count rising in the middle, and the bottom seat
 * left for whoever is reading. Signups land in the same waitlist;
 * only `source` differs, which is what makes the two pages comparable
 * afterwards instead of merely different.
 */
export function GroupLandingScreen() {
  return (
    <LandingShell source="web-landing-group">
      <GroupRing />
    </LandingShell>
  );
}
